import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Modal } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Header from '../../components/Header';
import MenuBox from '../../components/MenuBox';
import ShopContact from '../organisms/ShopContact';
import { isAuthenticated, signOut } from '../../auth/Auth';
import { removeToken } from '../../libs/apis/UserApi';

const styles = theme => ({
  root: {
    backgroundColor: '#fff',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  mainPaper: {
    margin: 15
  },
  pageTitileDiv: {
    paddingLeft: 16,
    paddingTop: 23,
    textAlign: 'left'
  },
  textTitle: {
    fontWeight: 'bold',
    fontSize: 24
  },
  mainModal: {
    zIndex: '99999!important'
  },
  buttonWrapper: {
    padding: '20px 20px 1px 20px',
    marginBottom: 39
  },
  button: {
    width: '100%',
    marginBottom: '19px',
    fontSize: 14,
    fontWeight: 'bold'
  },
  supportTimeTxt: {
    fontSize: 14,
    margin: '0 15px 15px'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    account: state.accounts.account,
    name: state.loginInfo.name
  })),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openShopContact', 'setOpenShopContact', false),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    name,
    handleRedirect,
    openShopContact,
    setOpenShopContact
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    const openChangeMail = () => {
      handleRedirect('/change_mail_shop');
    };
    const openChangePassword = () => {
      handleRedirect('/change_pass_shop');
    };
    // const openContactAction = () => {
    //   setOpenShopContact(true);
    // };

    const signOutAction = async () => {
      // remove token
      const currentToken = localStorage.getItem('firebaseToken');
      removeToken({
        pushToken: currentToken
      })
        .then(() => {
          console.log('remove token success');
        })
        .catch(() => {
          console.log('remove token failed');
        });

      signOut();
      handleRedirect('/');
    };

    // check if is account shop
    if (!(isShop && isReleased)) {
      handleRedirect('/shops');
    }
    return (
      <div className={classes.root}>
        <Header name={name} />
        <div className={classes.pageTitileDiv}>
          <Typography color="textPrimary" className={classes.textTitle}>
            設定
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.buttonWrapper}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={openChangeMail}
            >
              メールアドレス変更
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={openChangePassword}
            >
              パスワード変更
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              target="_blank"
              href="https://support.gochimeshi.com/s/"
            >
              よくあるご質問
            </Button>
            {/* <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={openContactAction}
            >
              お問い合わせ
            </Button> */}
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              target="_blank"
              href="https://support.gochimeshi.com/s/article/contact-for-unresolved-issues/"
            >
              お問い合わせ
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              target="_blank"
              href="https://docs.google.com/forms/d/e/1FAIpQLSdDAonXzAynWrI5eQHpgGtpPFB0Q_5s5Icalwv475nnN5O-gA/viewform?usp=send_form"
            >
              閉店したい
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={signOutAction}
            >
              ログアウト
            </Button>
          </div>
        </Paper>

        <MenuBox account={account} />
        <div>
          <Modal open={openShopContact} className={classes.mainModal}>
            <ShopContact setOpenShopContact={setOpenShopContact} />
          </Modal>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
